import $ from 'jquery';
//Moves the breadcrumb to any .breadcrumb-anchor to fasilitate placement within other modules
function breadcrumb() {}

export default breadcrumb;
